export const authSignUp = (data) => {

    const errors = {};
    //First name
    if (!/([^\s])/.test(data["firstName"])) errors["firstName"] = "First Name is Required";

    //Last name
    if (!/([^\s])/.test(data["lastName"])) errors["lastName"] = "Last Name is Required";

    //Email
    if (!/([^\s])/.test(data["email"])) errors["email"] = "Email ID is Required";
    else if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        data["email"]
    ) && data["email"].length > 0) {
        errors["email"] = "Enter Valid Email ID";
    }
    else if (/\s/g.test(data["email"])) errors["email"] = "Enter Valid Email ID";

    //Password
    if (!/([^\s])/.test(data["password"])) errors["password"] = "Password is Required";
    else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!-/:-@[-`{-~]{6,}$/.test(data["password"])) {
        errors["password"] = "Password must be 6 characters long, should contain at least 1 uppercase, 1 lowercase, 1 numeric or special character.";
    }

    return Object.keys(errors).length === 0 ? null : errors;
}

export const authSingIn = (data) => {

    const errors = {};
    //Email
    if (data.email === undefined || data.email === '') errors["email"] = "Email ID is Required.";
    else if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        data["email"]
    ) && data["email"]?.length > 0) {
        errors["email"] = "Enter Valid Email ID";
    }
    else if (/\s/g.test(data["email"])) errors["email"] = "Enter Valid Email ID";

    //Password
    if (data.password === undefined || data.password === '') errors["password"] = "Password is Required";
    // else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!-/:-@[-`{-~]{6,}$/.test(data["password"])) {
    //     errors["password"] = "Invalid Credentials Please Check Email And Password";
    // }

    return Object.keys(errors).length === 0 ? null : errors;
}

export const authForgot = (data) => {

    const errors = {};

    //Email
    if (!/([^\s])/.test(data["email"])) errors["email"] = "Email ID is Required.";

    else if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        data["email"]
    ) && data["email"].length > 0) {
        errors["email"] = "Enter Valid Email ID";
    }

    return Object.keys(errors).length === 0 ? null : errors;
}

export const authReset = (data) => {

    const errors = {};
    //Set password
    if (!/([^\s])/.test(data["password"])) errors["password"] = "Password is Required.";
    else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!-/:-@[-`{-~]{6,}$/.test(data["password"])) {
        errors["password"] = "Enter Valid Password";
    }

    //Confirm password
    if (!/([^\s])/.test(data['confirmPassword'])) errors["confirmPassword"] = "Please re-enter the new password to confirm it.";

    else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!-/:-@[-`{-~]{6,}$/.test(data["confirmPassword"])) {
        errors["confirmPassword"] = "Enter Valid Password";
    }

    else if (data['password'] !== data['confirmPassword'] && data['confirmPassword'].length > 0) {
        errors['confirmPassword'] = 'Password value does not match.'
    }

    return Object.keys(errors).length === 0 ? null : errors;
}

export const help = (data) => {

    const errors = {};
    //First name
    if (!/([^\s])/.test(data["firstName"])) errors["firstName"] = "First Name is Required";

    //Last name
    if (!/([^\s])/.test(data["lastName"])) errors["lastName"] = "Last Name is Required";

    //Email
    if (!/([^\s])/.test(data["email"])) errors["email"] = "Email ID is Required";
    else if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        data["email"]
    ) && data["email"].length > 0) {
        errors["email"] = "Enter Valid Email ID";
    }
    else if (/\s/g.test(data["email"])) errors["email"] = "Enter Valid Email ID";

    return Object.keys(errors).length === 0 ? null : errors;
}

export const reportSuggestion = (data) => {

    const errors = {};
    //Title
    if (!/([^\s])/.test(data["title"])) errors["title"] = "Title is Required";

    //Description
    if (!/([^\s])/.test(data["description"])) errors["description"] = "Description of The Suggestion is Required";

    return Object.keys(errors).length === 0 ? null : errors;
}

export const routeNameValidation = (data) => {

    const errors = {};
    //Route Name
    if (!/([^\s])/.test(data["routeName"])) errors["routeName"] = "Enter Route Name";

    return Object.keys(errors).length === 0 ? null : errors;
}

